import React, { createContext, FC, useReducer } from 'react';
import { message } from 'antd';
import cheerio from 'cheerio';
import { api } from '../../api';
import { logout } from './auth.action';
import { authReducer } from './auth.reducer';
import { AuthContextType, AuthProviderProps, AuthStateType } from './auth.types';

const initialState: AuthStateType = {
  token: localStorage.getItem('userToken') || null,
  isExpert: false,
  isFederal: false,
  isRepresentative: false,
  isNms: false,
  isPovs: false,
  isSuperFederal: false,
  isAdmin: false,
};

export const authContext = createContext<AuthContextType>({
  state: initialState,
  dispatch: () => null,
});

const { Provider } = authContext;

export const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.headers['content-type'].includes('text/html')) {
        const $ = cheerio.load(error.response.data);
        const errorMessage = $('.exception-message').text();

        if (errorMessage.includes('Этот адрес электронной почты уже используется'))
          message.error(errorMessage.split(':')[1].split('(')[0]).then();
        else if (errorMessage.includes('Expired JWT Token')) {
          dispatch(logout());
        }
      } else if (error.response.data.detail.includes('Invalid JWT Token')) {
        dispatch(logout());
      }

      return Promise.reject(error);
    },
  );

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};
